import { gql } from "@apollo/client";

export const GET_ZIPCODE_MAP_BOUNDARIES = gql`
    query GetZipcodeMapBoundaries($zipcodes: [String!]!) {
        getZipcodeMapBoundaries(zipcodes: $zipcodes) {
            zipcode
            geometryType
            boundary
        }
    }
`;

export interface ZipcodeMapBoundaryItem {
    zipcode: string;
    geometryType: string;
    boundary: string;
}

export interface GetZipcodeMapBoundariesResponse {
    getZipcodeMapBoundaries: ZipcodeMapBoundaryItem[];
}